// The backend's vocabulary in words: the intent of a question or of a whole
// conversation (core/classify.py), the affect tags of a message, the topics
// the Beruf persona tells (core/profession_topics.py), the role a place plays
// in a question, and an interest term's trend. The ids travel and the
// dashboard translates them; an id a newer backend adds reads as itself.

import type { InterestTrend, PlaceRole } from "@/api/types";
import { t, tOr } from "@/i18n";

export const intentLabel = (intent: string): string => tOr(`intent.${intent}`, intent);

export const affectLabel = (affect: string): string => tOr(`affect.${affect}`, affect);

export const professionTopicLabel = (topic: string): string =>
  tOr(`professionTopic.${topic}`, topic);

export const placeRoleLabel = (role: PlaceRole): string => t(`place.${role}`);

export const trendLabel = (trend: Exclude<InterestTrend, "">): string => t(`trend.${trend}`);
